export default {
  state: {
    profile: {},
    updateProfile: false,
  },

  getters: {
    getProfile(state) {
      return state.profile;
    },

    getProfileType(state) {
      return state.updateProfile;
    },
  },

  mutations: {
    setProfile(state, data) {
      const isUpdate = Object.keys(data).length > 0;
      state.updateProfile = isUpdate;

      state.profile = {
        id: isUpdate ? data.id : "",
        name: isUpdate ? data.name : "",
        description: isUpdate ? data.description : "",
      };
    },
  },

  actions: {
    changeProfile(context, data) {
      context.commit("setProfile", data);
    },
  },
};
